var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"to-center-abs",class:_vm.$store.getters['getLocale'],attrs:{"id":"league-hero-box"}},[_c('info-badge',{attrs:{"id":"info-league","placement":"left","info-text":_vm.$t('info_badge.league'),"size":"lg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }